module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "emoji-picker",
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "emoji-top"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "emoji-search",
    attrs: {
      "type": "text",
      "placeholder": "Buscar emoji..."
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "emoji-close",
    attrs: {
      "aria-label": "Fechar"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "emoji-tabs"
  }, _vm._l((_vm.categories), function(c) {
    return _c('button', {
      key: c.key,
      staticClass: "emoji-tab",
      class: {
        active: c.key === _vm.activeCategory
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.activeCategory = c.key
        }
      }
    }, [_c('span', [_vm._v(_vm._s(c.icon))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "emoji-grid"
  }, [_vm._l((_vm.filteredEmojis), function(e) {
    return _c('button', {
      key: e,
      staticClass: "emoji-item",
      attrs: {
        "type": "button",
        "title": _vm.emojiTitle(e)
      },
      on: {
        "click": function($event) {
          return _vm.selectEmoji(e)
        }
      }
    }, [_vm._v(_vm._s(e))])
  }), _vm._v(" "), (!_vm.filteredEmojis.length) ? _c('div', {
    staticClass: "emoji-empty"
  }, [_vm._v("Nada encontrado")]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-081d1cfb","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/chat-plugin/components/EmojiPicker.vue
// module id = 1657
// module chunks = 18